/*
 * Authors: mariushirjanu
 * Created: 05/06/2023
 */

import { Injectable } from '@angular/core';
import { IObject } from '../../../../type_definitions/datatypes';

@Injectable()
export class AgCellEditorService {
  private _unsavedRowData:IObject;

  constructor() {
    /***/
  }

  public set rowData(data:IObject) {
    this._unsavedRowData = data;
  }

  public get rowData():IObject {
    return this._unsavedRowData;
  }
}